import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import authReducer from './slices/authSlice';
import setupReducer from './slices/setupSlice';
import newsReducer from './slices/newsSlice';
import locationReducer from './slices/locationSlice';
import settingsReducer from './slices/settingsSlice';
import conversationReducer from './slices/conversationSlice';
import navigationReducer from './slices/navigationSlice';
import swipeReducer from './slices/swipeSlice';
import exitStrategyReducer from './slices/exitStrategySlice';
import opaqueCardsReducer from './slices/opaqueCardsSlice';
import cardLayeringReducer from './slices/cardLayeringSlice';
import emptyStateReducer from './slices/emptyStateSlice';
import fixEmptyStateIssuesReducer from './slices/fixEmptyStateIssuesSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    setup: setupReducer,
    news: newsReducer,
    location: locationReducer,
    settings: settingsReducer,
    conversations: conversationReducer,
    navigation: navigationReducer,
    swipe: swipeReducer,
    exitStrategy: exitStrategyReducer,
    opaqueCards: opaqueCardsReducer,
    cardLayering: cardLayeringReducer,
    emptyState: emptyStateReducer,
    fixEmptyStateIssues: fixEmptyStateIssuesReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;